// extracted by mini-css-extract-plugin
module.exports = {"active":"UserRoleChangeButton-active-5f22bd6991d1e1d8f3a2a5ca10845378"};